import { getIsNonEmpty } from '../../utilities/lang'
import { getIsLocale } from '../lib'
import getLocaleFromLocalizedUrl from '../lib/getLocaleFromLocalizedUrl'
import { defaultLocale } from '../supportedLocales'

/**
 * This function takes in a URL and returns it wrapped with supported locale
 *
 * @param {Location} location - Location object which contains URL
 * @param {string} locale - Locale to wrap non-localized or unsupported locale
 * URL with
 *
 * @returns a URL of the format `origin/locale/newUrlPath(s)/?search`
 */
const getLocalizedUrl = (location: Location, locale: string) => {
  const { origin, pathname, search } = location
  const urlParts = pathname.split('/').filter(getIsNonEmpty)
  const existingLocaleInUrl = getLocaleFromLocalizedUrl(pathname) || ''

  const newUrlPath = getIsLocale(existingLocaleInUrl)
    ? urlParts.slice(1).join('/')
    : urlParts.join('/')

  const reconstructedUrlParts = [
    origin,
    /**
     * If it's the defaultLocale, then we don't include it
     * as part of the URL.
     */
    locale === defaultLocale ? '' : locale,
    newUrlPath,
    search,
  ]

  return reconstructedUrlParts.filter(getIsNonEmpty).join('/')
}

export default getLocalizedUrl
